import { useContext } from 'react';
import { ReportContext } from '../../../context/ReportContext';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import SimpleDataGrid from '../../Tables/SimpleDataGrid';
import SimpleDataGridItem from '../../Tables/SimpleDataGridItem';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserCallsToActionAggregate = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [
        {
            field: 'resourceTitle',
            name: 'Linked Resource Title',
            dataType: 'multiselect',
            styles: { minWidth: '20rem' },
        },
        {
            field: 'views',
            name: 'Views',
            dataType: 'numeric',
        },
        {
            field: 'clicks',
            name: 'Clicks',
            dataType: 'numeric',
        },
    ];

    return (
        <div className="space-y-6">
            <div>
                <SimpleDataGrid>
                    <SimpleDataGridItem
                        label="Total Views:"
                        value={reportData.totalViews}
                    />
                    <SimpleDataGridItem
                        label="Total Clicks:"
                        value={reportData.totalClicks}
                    />
                </SimpleDataGrid>
            </div>

            <StandardizedDataTable data={reportData.callsToAction} columns={columns} />

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report provides an aggregate view of user interactions with
                    calls-to-action (CTAs) within the platform for the selected time
                    period and filters.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Total Views">
                    The total number of times users viewed any call-to-action element
                    across all resources.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Total Clicks">
                    The total number of times users followed the link on call-to-action
                    elements, indicating engagement with the promoted content or actions.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Linked Resource Table">
                    The table shows a more broken down view of the data above with the
                    individual CTA performance with view and click metrics. If the linked
                    content is an external resource, it will have the fallback value of
                    "Dashboard CTA".
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserCallsToActionAggregate;
